"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CCheckBox = _interopRequireDefault(require("01_core/components/materials/CCheckBox"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CLink = _interopRequireDefault(require("01_core/components/materials/CLink"));
var _CTextField = _interopRequireDefault(require("01_core/components/materials/CTextField"));
var _InputFile = _interopRequireDefault(require("01_core/components/materials/InputFile"));
var _ListIconButton = _interopRequireDefault(require("01_core/components/materials/ListIconButton"));
var _InputDateTime = _interopRequireDefault(require("01_core/components/select/InputDateTime"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _APIs = require("01_core/constants/APIs");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringConsts = require("01_core/constants/stringConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _Consts = require("../../common/consts/Consts");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const INDENT_PX = 12;
const SMALL_INDENT_PX = 6;
const OtherLabelTypography = (0, _styles.styled)(_material.Typography)(_ref => {
  let {
    theme
  } = _ref;
  return {
    marginTop: theme.spacing(1.2),
    marginRight: theme.spacing(1.2),
    display: 'inline-block',
    fontSize: theme.typography.body2.fontSize
  };
});
const IndentTypography = (0, _styles.styled)(_material.Typography)({
  marginLeft: "".concat(INDENT_PX, "px")
});
const PreLineIndentTypography = (0, _styles.styled)(_material.Typography)({
  whiteSpace: 'pre-line',
  marginLeft: "".concat(INDENT_PX, "px")
});
const TargetRiskCheckBox = (0, _styles.styled)(_CCheckBox.default)({
  marginLeft: "".concat(SMALL_INDENT_PX, "px")
});
const KunrenPeriodCheckBox = (0, _styles.styled)(_CCheckBox.default)({
  marginLeft: "".concat(SMALL_INDENT_PX, "px")
});

/**
 * 訓練実施報告登録：実施詳細
 */
class ReportGuidelinesField extends _react.default.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "disableCheck", item => {
      let tgtRiskFlg = true;
      let kunrenPeriodFlg = true;
      this.props.reportEntry.checkStatusList.forEach(data => {
        if (data.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_01 && data.groupId === _CodeConsts.CODE.BCM_KR_GROUP.CODE_1) {
          if (data.activityFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1) {
            tgtRiskFlg = false;
          }
        }
        if (data.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_01 && data.groupId === _CodeConsts.CODE.BCM_KR_GROUP.CODE_2) {
          if (data.activityFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1) {
            kunrenPeriodFlg = false;
          }
        }
      });
      if (item.groupId === _CodeConsts.CODE.BCM_KR_GROUP.CODE_1) {
        return tgtRiskFlg;
      } else {
        return kunrenPeriodFlg;
      }
    });
    _defineProperty(this, "textCheck", () => {
      const text = this.props.reportEntry.checkStatusList.filter(item => {
        if (item.guidelineCd === _Consts.CONSTS.GUIDELINE_OTHER) {
          return true;
        }
        return false;
      });
      return text[0] && text[0].notes ? true : false;
    });
    // チェックボックス変更時
    _defineProperty(this, "changeCheckBox", (data, key) => value => {
      const list = this.props.reportEntry.checkStatusList.slice();
      const idx = list.indexOf(data);
      if (idx >= 0) {
        list[idx] = _objectSpread(_objectSpread({}, data), {}, {
          [key]: value ? _CodeConsts.CODE.FLG_VALUE.CODE_1 : _CodeConsts.CODE.FLG_VALUE.CODE_0
        });
      }
      this.props.setEntry('checkStatusList')(list);
      this.props.setFormValue && this.props.setFormValue('checkStatusList', list, {
        shouldValidate: false,
        shouldDirty: false
      });
    });
    // チェックボックス変更時
    _defineProperty(this, "changeNote", data => value => {
      const list = this.props.reportEntry.checkStatusList.slice();
      const idx = list.indexOf(data);
      if (idx >= 0) {
        list[idx] = _objectSpread(_objectSpread({}, data), {}, {
          activityFlg: value === '' ? _CodeConsts.CODE.FLG_VALUE.CODE_0 : _CodeConsts.CODE.FLG_VALUE.CODE_1,
          notes: value
        });
      }
      this.props.setEntry('checkStatusList')(list);
      this.props.setFormValue && this.props.setFormValue('checkStatusList', list, {
        shouldValidate: false,
        shouldDirty: false
      });
    });
    // ファイル追加処理
    _defineProperty(this, "addFile", target => {
      const {
        kunrenInfo,
        callAPIMultipart,
        reportEntry,
        setEntry,
        openInfoBar,
        intl
      } = this.props;
      if (target) {
        // ファイルの重複チェック
        let errorFlg = false;
        reportEntry.fileList.map(item => {
          if (item.fileNm === target.name) {
            openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
              id: _labelConsts.LABEL.BCM_KUNREN_REPORT_FILE_DUPLICATE_MESSAGE
            }));
            errorFlg = true;
          }
          return null;
        });
        if (!errorFlg) {
          let sendData = new FormData();
          sendData.append('targetCd', kunrenInfo.targetCd);
          sendData.append('bcmKaishaSoshikiCd', kunrenInfo.bcmKaishaSoshikiCd);
          sendData.append('bcpTgtJigyoCd', kunrenInfo.bcpTgtJigyoCd);
          sendData.append('fileNo', reportEntry.fileList.length + 1);
          sendData.append('fileNm', target.name);
          sendData.append('uploadFile', target);
          callAPIMultipart(_APIs.BCM_KUNREN_REPORT_FILE_UPLOAD, sendData).then(response => {
            if (response.status === _APIs.STATUS.SUCCESS) {
              const fileList = reportEntry.fileList.slice();
              fileList.push({
                fileNm: target.name,
                uploadFile: target
              });
              setEntry('fileList')(fileList);
            } else {
              this.props.intl.formatMessage({
                id: _labelConsts.LABEL.CORE_FILE_UPLOAD_FAILED
              });
            }
          });
        }
      }
    });
    // ファイルダウンロード処理
    _defineProperty(this, "downloadFile", item => {
      const {
        kunrenInfo
      } = this.props;
      this.props.callAPIRawResponse(_APIs.BCM_KUNREN_REPORT_FILE_DOWNLOAD, {
        targetCd: kunrenInfo.targetCd,
        bcmKaishaSoshikiCd: kunrenInfo.bcmKaishaSoshikiCd,
        bcpTgtJigyoCd: kunrenInfo.bcpTgtJigyoCd,
        fileNo: item.fileNo,
        fileNm: item.fileNm
      }).then(response => response.blob()).then(blob => {
        if (blob.size > 0) {
          let anchor = document.createElement('a');
          anchor.download = item.fileNm;
          anchor.href = window.URL.createObjectURL(blob);
          anchor.click();
        } else {
          this.props.openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, this.props.intl.formatMessage({
            id: _labelConsts.LABEL.CORE_FILE_NOT_FOUND_MESSAGE
          }));
        }
      });
    });
    // ファイル削除処理
    _defineProperty(this, "deleteFile", item => {
      const {
        kunrenInfo
      } = this.props;
      this.props.callAPIRawResponse(_APIs.BCM_KUNREN_REPORT_FILE_DELETE, {
        targetCd: kunrenInfo.targetCd,
        bcmKaishaSoshikiCd: kunrenInfo.bcmKaishaSoshikiCd,
        bcpTgtJigyoCd: kunrenInfo.bcpTgtJigyoCd,
        fileNo: item.fileNo,
        fileNm: item.fileNm
      }).then(response => response.blob());
      const fileList = this.props.reportEntry.fileList.slice();
      fileList.splice(fileList.indexOf(item), 1);
      this.props.setEntry('fileList')(fileList);
    });
    _defineProperty(this, "targetRiskList", () => {
      const {
        reportEntry,
        errors
      } = this.props;
      let targetRiskList = [];
      if (reportEntry.scenarioPolicyCd === _CodeConsts.CODE.BCM_SCENARIO.CODE_03 || !reportEntry.scenarioPolicyCd) {
        reportEntry.checkStatusList.forEach((item, index) => {
          if (item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_01) {
            if (item.guidelineCd === _Consts.CONSTS.GUIDELINE_OTHER) {
              var _errors$checkStatusLi, _errors$checkStatusLi2;
              targetRiskList.push(/*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
                key: index
              }, /*#__PURE__*/_react.default.createElement(OtherLabelTypography, {
                component: "span"
              }, item.contents), /*#__PURE__*/_react.default.createElement(_CTextField.default, {
                value: item.notes,
                onChange: this.changeNote(item),
                maxLength: 10,
                fullWidth: false,
                error: !!(errors !== null && errors !== void 0 && (_errors$checkStatusLi = errors.checkStatusList) !== null && _errors$checkStatusLi !== void 0 && (_errors$checkStatusLi = _errors$checkStatusLi[index]) !== null && _errors$checkStatusLi !== void 0 && _errors$checkStatusLi.notes),
                helperText: errors === null || errors === void 0 || (_errors$checkStatusLi2 = errors.checkStatusList) === null || _errors$checkStatusLi2 === void 0 || (_errors$checkStatusLi2 = _errors$checkStatusLi2[index]) === null || _errors$checkStatusLi2 === void 0 || (_errors$checkStatusLi2 = _errors$checkStatusLi2.notes) === null || _errors$checkStatusLi2 === void 0 ? void 0 : _errors$checkStatusLi2.message
              })));
            } else {
              targetRiskList.push(/*#__PURE__*/_react.default.createElement(TargetRiskCheckBox, {
                key: index,
                label: item.contents,
                checked: item.activityFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1,
                onChange: this.changeCheckBox(item, 'activityFlg'),
                color: "secondary",
                labelVariant: "body2"
              }));
            }
          }
        });
      } else {
        reportEntry.checkStatusList.forEach((item, index) => {
          if (item.guidelineCd === _Consts.CONSTS.GUIDELINE_OTHER) {
            if (item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_01 && item.activityFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1) {
              if (targetRiskList.length !== 0) {
                targetRiskList.push(_stringConsts.STRING_CONSTS.TOUTEN_ZENKAKU);
              }
              targetRiskList.push(item.notes);
            }
          } else {
            if (item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_01 && item.activityFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1) {
              if (targetRiskList.length !== 0) {
                targetRiskList.push(_stringConsts.STRING_CONSTS.TOUTEN_ZENKAKU);
              }
              targetRiskList.push(item.contents);
            }
          }
        });
        if (targetRiskList.length !== 0) {
          targetRiskList = /*#__PURE__*/_react.default.createElement(IndentTypography, null, targetRiskList);
        }
      }
      if (targetRiskList.length === 0) {
        targetRiskList.push(/*#__PURE__*/_react.default.createElement(IndentTypography, {
          key: "empty"
        }, _stringConsts.STRING_CONSTS.HYPHEN_ZENKAKU));
      }
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, targetRiskList, !!(errors !== null && errors !== void 0 && errors.checkStatusList) && /*#__PURE__*/_react.default.createElement(_material.FormHelperText, {
        error: true
      }, errors.checkStatusList.message));
    });
    _defineProperty(this, "kunrenPeriodList", () => {
      const {
        reportEntry
      } = this.props;
      let kunrenPeriodList = [];
      if (reportEntry.scenarioPolicyCd === _CodeConsts.CODE.BCM_SCENARIO.CODE_03 || !reportEntry.scenarioPolicyCd) {
        reportEntry.checkStatusList.forEach((item, index) => {
          if (item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_02 && (!this.disableCheck(item) || this.textCheck())) {
            kunrenPeriodList.push(/*#__PURE__*/_react.default.createElement(KunrenPeriodCheckBox, {
              key: index,
              label: item.contents,
              checked: item.activityFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1,
              onChange: this.changeCheckBox(item, 'activityFlg'),
              color: "secondary",
              labelVariant: "body2"
            }));
          }
        });
      } else {
        reportEntry.checkStatusList.forEach((item, index) => {
          if (item.checkKbn === _CodeConsts.CODE.BCM_KJ_DATA_KBN.CODE_02 && item.activityFlg === _CodeConsts.CODE.FLG_VALUE.CODE_1) {
            if (kunrenPeriodList.length !== 0) {
              kunrenPeriodList.push(_stringConsts.STRING_CONSTS.TOUTEN_ZENKAKU);
            }
            kunrenPeriodList.push(item.contents);
          }
        });
        if (kunrenPeriodList.length !== 0) {
          kunrenPeriodList = /*#__PURE__*/_react.default.createElement(IndentTypography, null, kunrenPeriodList);
        }
      }
      if (kunrenPeriodList.length === 0) {
        kunrenPeriodList.push(/*#__PURE__*/_react.default.createElement(IndentTypography, {
          key: "empty"
        }, _stringConsts.STRING_CONSTS.HYPHEN_ZENKAKU));
      }
      return kunrenPeriodList;
    });
  }
  render() {
    var _errors$exercisesDt, _errors$riskDetailNot, _errors$kunrenPurpose, _errors$kunrenContent, _errors$supplement, _errors$partcipant, _errors$kunrenResult;
    const {
      intl,
      reportEntry,
      errors,
      setFormValue
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        lg: 6,
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_JISSHI_DT
      })
    }, /*#__PURE__*/_react.default.createElement(_InputDateTime.default, {
      value: reportEntry.exercisesDt,
      onChange: v => {
        this.props.setEntry('exercisesDt')(v);
        setFormValue && setFormValue('exercisesDt', v, {
          shouldValidate: false,
          shouldDirty: false
        });
      },
      name: 'exercisesDt',
      error: !!(errors !== null && errors !== void 0 && errors.exercisesDt),
      helperText: errors === null || errors === void 0 || (_errors$exercisesDt = errors.exercisesDt) === null || _errors$exercisesDt === void 0 ? void 0 : _errors$exercisesDt.message
    }))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        lg: 12,
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_TGT_RISK
      }),
      hint: _labelConsts.LABEL.BCM_KUNREN_REPORT_TGT_RISK_HINT
    }, this.targetRiskList())), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        lg: 3,
        xs: 3
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_TGT_RISK_DETAIL
      }),
      hint: _labelConsts.LABEL.BCM_KUNREN_REPORT_TGT_RISK_DETAIL_HINT
    }, reportEntry.scenarioPolicyCd === _CodeConsts.CODE.BCM_SCENARIO.CODE_03 || !reportEntry.scenarioPolicyCd ? /*#__PURE__*/_react.default.createElement(_CTextField.default, {
      value: reportEntry.riskDetailNotes,
      onChange: v => {
        this.props.setEntry('riskDetailNotes')(v);
        setFormValue && setFormValue('riskDetailNotes', v, {
          shouldValidate: false,
          shouldDirty: false
        });
      },
      maxLength: 1000,
      multiline: true,
      rows: 3,
      error: !!(errors !== null && errors !== void 0 && errors.riskDetailNotes),
      helperText: errors === null || errors === void 0 || (_errors$riskDetailNot = errors.riskDetailNotes) === null || _errors$riskDetailNot === void 0 ? void 0 : _errors$riskDetailNot.message
    }) : /*#__PURE__*/_react.default.createElement(PreLineIndentTypography, null, _stringUtil.default.emptyToHyphen(reportEntry.riskDetailNotes)))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        lg: 9,
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_PERIOD
      }),
      hint: _labelConsts.LABEL.BCM_KUNREN_REPORT_PERIOD_HINT
    }, this.kunrenPeriodList())), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        lg: 3,
        xs: 6
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_PURPOSE
      })
    }, reportEntry.scenarioPolicyCd === _CodeConsts.CODE.BCM_SCENARIO.CODE_03 || !reportEntry.scenarioPolicyCd ? /*#__PURE__*/_react.default.createElement(_CTextField.default, {
      value: reportEntry.kunrenPurpose,
      onChange: v => {
        this.props.setEntry('kunrenPurpose')(v);
        setFormValue && setFormValue('kunrenPurpose', v, {
          shouldValidate: false,
          shouldDirty: false
        });
      },
      maxLength: 1000,
      multiline: true,
      rows: 3,
      error: !!(errors !== null && errors !== void 0 && errors.kunrenPurpose),
      helperText: errors === null || errors === void 0 || (_errors$kunrenPurpose = errors.kunrenPurpose) === null || _errors$kunrenPurpose === void 0 ? void 0 : _errors$kunrenPurpose.message
    }) : /*#__PURE__*/_react.default.createElement(PreLineIndentTypography, null, _stringUtil.default.emptyToHyphen(reportEntry.kunrenPurpose)))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        lg: 3,
        xs: 6
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_CONTENT
      })
    }, reportEntry.scenarioPolicyCd === _CodeConsts.CODE.BCM_SCENARIO.CODE_03 || !reportEntry.scenarioPolicyCd ? /*#__PURE__*/_react.default.createElement(_CTextField.default, {
      value: reportEntry.kunrenContent,
      onChange: v => {
        this.props.setEntry('kunrenContent')(v);
        setFormValue && setFormValue('kunrenContent', v, {
          shouldValidate: false,
          shouldDirty: false
        });
      },
      maxLength: 1000,
      multiline: true,
      rows: 3,
      error: !!(errors !== null && errors !== void 0 && errors.kunrenContent),
      helperText: !!(errors !== null && errors !== void 0 && errors.kunrenContent) && (errors === null || errors === void 0 || (_errors$kunrenContent = errors.kunrenContent) === null || _errors$kunrenContent === void 0 ? void 0 : _errors$kunrenContent.message)
    }) : /*#__PURE__*/_react.default.createElement(PreLineIndentTypography, null, _stringUtil.default.emptyToHyphen(reportEntry.kunrenContent)))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        lg: 3,
        xs: 6
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_SUPPLEMENT
      })
    }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
      value: reportEntry.supplement,
      onChange: v => {
        this.props.setEntry('supplement')(v);
        setFormValue && setFormValue('supplement', v, {
          shouldValidate: false,
          shouldDirty: false
        });
      },
      maxLength: 1000,
      multiline: true,
      rows: 3,
      error: !!(errors !== null && errors !== void 0 && errors.supplement),
      helperText: errors === null || errors === void 0 || (_errors$supplement = errors.supplement) === null || _errors$supplement === void 0 ? void 0 : _errors$supplement.message
    }))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        lg: 3,
        xs: 6
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_PARTICIPANT
      })
    }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
      value: reportEntry.partcipant,
      onChange: v => {
        this.props.setEntry('partcipant')(v);
        setFormValue && setFormValue('partcipant', v, {
          shouldValidate: false,
          shouldDirty: false
        });
      },
      maxLength: 6,
      error: !!(errors !== null && errors !== void 0 && errors.partcipant),
      helperText: errors === null || errors === void 0 || (_errors$partcipant = errors.partcipant) === null || _errors$partcipant === void 0 ? void 0 : _errors$partcipant.message
    }))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        lg: 3,
        xs: 6
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_PARTICIPANT_LIST
      }),
      hint: _labelConsts.LABEL.BCM_KUNREN_REPORT_PARTICIPANT_LIST_HINT
    }, /*#__PURE__*/_react.default.createElement(_InputFile.default, {
      onChange: target => this.addFile(target),
      noDisplay: true
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_ADD_FILE
    })), /*#__PURE__*/_react.default.createElement(_material.Table, null, /*#__PURE__*/_react.default.createElement(_material.TableBody, null, reportEntry.fileList.map((item, index) => {
      return /*#__PURE__*/_react.default.createElement(_material.TableRow, {
        key: index
      }, /*#__PURE__*/_react.default.createElement(_material.TableCell, {
        style: {
          width: 60,
          minWidth: 60,
          maxWidth: 60
        }
      }, /*#__PURE__*/_react.default.createElement(_ListIconButton.default, {
        action: "delete",
        onClick: () => {
          this.deleteFile(item);
        }
      })), /*#__PURE__*/_react.default.createElement(_material.TableCell, null, /*#__PURE__*/_react.default.createElement(_CLink.default, {
        onClick: () => this.downloadFile(item)
      }, item.fileNm)));
    }))))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      size: {
        lg: 3,
        xs: 6
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_RESULT
      })
    }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
      value: reportEntry.kunrenResult,
      onChange: v => {
        this.props.setEntry('kunrenResult')(v);
        setFormValue && setFormValue('kunrenResult', v, {
          shouldValidate: false,
          shouldDirty: false
        });
      },
      maxLength: 1000,
      multiline: true,
      rows: 3,
      error: !!(errors !== null && errors !== void 0 && errors.kunrenResult),
      helperText: errors === null || errors === void 0 || (_errors$kunrenResult = errors.kunrenResult) === null || _errors$kunrenResult === void 0 ? void 0 : _errors$kunrenResult.message
    }))));
  }
}
const mapStateToProps = state => ({
  reportErrMsg: state.bcmKunren.reportErrMsg
});
const mapDispatchToProps = dispatch => {
  return {
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CodeUtil.withCodeUtil)((0, _CallAPI.withCallAPI)(ReportGuidelinesField))));